import * as React from "react";
import { Typography } from "@mui/material";

export const PolicyWizardComponent: React.VoidFunctionComponent = () => {
  return <Typography>Policy Wizard is under development</Typography>;
};
